module.exports = __webpack_public_path__ + "static/media/1010662.006f5447.jpg";